import {Box, Stack, Typography} from "@mui/material";
import {blue, grey} from "@mui/material/colors";
import RadioButtonCheckedOutlinedIcon from "@mui/icons-material/RadioButtonCheckedOutlined";
import RadioButtonUncheckedOutlinedIcon from "@mui/icons-material/RadioButtonUncheckedOutlined";
import {Option} from "@/types/utils.ts";
import {useAppContext} from "@/contexts/AppContext.tsx";

export default function LargeOptionDefault({value, options, callback}: {
    value: string,
    options: Option[],
    callback: (type: string) => void
}) {
    const {uiVisual, theme} = useAppContext();
    const block = {
        classic: {
            bgcolor: theme === 'dark' ? grey[200] : grey[100],
            color: grey[900],
            borderRadius: 1
        },
        modern: {
            bgcolor: '#f1f5ff',
            color: blue[900],
            borderRadius: 2
        }
    };
    const badge = {
        classic: {
            bgcolor: grey[300],
            color: grey[900],
        },
        modern: {
            bgcolor: '#dae3ff',
            color: blue[900],
        }
    }

    return (
        <Stack direction="row">
            {options.map((option) => {
                return (
                    <Stack
                        key={option.key}
                        direction="row"
                        onClick={() => callback(option.key)}
                        width="100%"
                        p={2}
                        bgcolor={value === option.key ? block[uiVisual].bgcolor : 'white'}
                        borderRadius={block[uiVisual].borderRadius}
                        sx={{cursor: 'pointer'}}
                    >
                        {value === option.key ? (
                            <RadioButtonCheckedOutlinedIcon sx={{color: block[uiVisual].color, mr: 2, my: 'auto'}}/>
                        ) : (
                            <RadioButtonUncheckedOutlinedIcon sx={{color: block[uiVisual].color, mr: 2, my: 'auto'}}/>
                        )}
                        <Box my="auto">
                            <Typography fontSize={13} fontWeight={500}>{option.title}</Typography>
                            {option.label && (
                                <Typography display="inline-block"
                                            mb={0.75}
                                            fontSize={10}
                                            py={0.25}
                                            px={0.75}
                                            bgcolor={badge[uiVisual].bgcolor}
                                            color={badge[uiVisual].color}
                                            borderRadius={2}
                                >
                                    {option.label}
                                </Typography>
                            )}
                            <Typography fontSize={13} color={grey[700]}>
                                {option.description}
                            </Typography>
                        </Box>
                    </Stack>
                )
            })}
        </Stack>
    )
}